export * from "./vrMultiviewToSingleviewPostProcess.pure";

import "../Shaders/vrMultiviewToSingleview.fragment";
